import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/coupon/CouponCard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
